import services from '@/config/api';
import { replace, result } from 'lodash';

const paramsParser = (
    inputString: string,
    params: { [key: string]: string | number },
) => {
    Object.entries(params).forEach(([key, value]) => {
        inputString = replace(inputString, `%${key}%`, String(value));
    });
    return inputString;
};

// Строим маршруты
export const getRoute = (
    service: string,
    route: string,
    params?: { [key: string]: string | number },
    query?: { [key: string]: string | number },
): string => {
    if (!services[service]) {
        console.error(service + ': no such service');
        return '';
    }
    let p = params
        ? paramsParser(services[service].routes[route], params)
        : services[service].routes[route];
    let q = '';
    if (query)
        Object.entries(query).forEach(([key, value]) => {
            q += `${q.length ? '&' : '?'}${key}=${value}`;
        });


    console.log('LOG:', 'p', p, 'q:', q);
    return `http${services[service].secure ? 's' : ''}://${
        services[service].domain
    }/${p}${q}`;
    return `https://adminpanel.akinshino.poselok33.ru/${p}${q}`;
};

// Открываем внешнюю ссылку
export const openExtUrl = (url: string, target = '_blank'): void => {
    url ? window.open(url, target) : console.error('No url given');
};

export const getURL = (): string => {
    const { VUE_APP_COMPONENT_SECURE, VUE_APP_COMPONENT_DOMAIN } = process.env;

    // return `http://localhost:8080`
    return `http${
        VUE_APP_COMPONENT_SECURE === 'true' ? 's' : ''
    }://${VUE_APP_COMPONENT_DOMAIN}`;


};
